<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col cols="12">
        <v-row justify="center">
          <v-col align="center" cols="6" md="2">
            <router-link :to="`/feeds-graph`">
              <v-icon color="#066a8c">mdi-chart-bar</v-icon>
              <div class="mnuBtn">Graphs</div>
            </router-link>
          </v-col>

          <v-col align="center" cols="6" md="2">
            <router-link :to="`/feeds`">
              <v-icon color="#066a8c">mdi-post-outline</v-icon>
              <div class="mnuBtn">Posts Log</div>
            </router-link>
          </v-col>

          <v-col align="center" cols="6" md="2" class="btn_bg">
            <router-link :to="`/events-log`">
              <v-icon color="#066a8c">mdi-calendar-clock</v-icon>
              <div class="mnuBtn">Activity Log</div>
            </router-link>
          </v-col>
        </v-row>

        <v-row>
          <div class="user-wrapper">
            <div
              class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50"
            >
              <div class="md-card md-theme-default">
                <div class="md-card-content">
                  <v-row>
                    <v-col md="3"
                      ><span class="header_title"> Activity Log</span></v-col
                    >
                  </v-row>
                  <v-row>
                    <v-col class="ml-4" cols="2">
                      <v-autocomplete
                        v-model="searchParams.time_intervel"
                        outlined
                        label="Time Period"
                        @change="changeFxn"
                        item-value="name"
                        item-text="title"
                        :items="timeDuration"
                      ></v-autocomplete>
                    </v-col>

                    <v-col class="ml-1" cols="4" v-if="flag">
                      <v-row>
                        <v-col cols="5" style="padding-right: 0">
                          <v-menu
                            v-model="menu1"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                outlined
                                background-color="#fff"
                                class="text1"
                                v-model="date1Formatted"
                                readonly
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="searchParams.start_date"
                              @input="menu1 = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="5">
                          <v-menu
                            v-model="menu2"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                class="text2"
                                v-model="date2Formatted"
                                outlined
                                background-color="#fff"
                                readonly
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="searchParams.end_date"
                              @input="menu2 = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="2">
                          <v-flex xs1 class="ml-1 mt-1">
                            <v-btn
                              color="#00b0af"
                              height="48"
                              dark
                              @click="search"
                              >Go</v-btn
                            >
                          </v-flex>
                        </v-col>
                      </v-row>
                    </v-col>

                    <v-spacer></v-spacer>
                    <v-col md="2" class="mr-3">
                      <div style="width: 120px; float: right">
                        <v-select
                          outlined
                          v-model="perPage"
                          label="Per Page"
                          :items="[10, 15, 25, 50]"
                          @change="eventsData"
                          :menu-props="{ bottom: true, offsetY: true }"
                        ></v-select>
                      </div>
                    </v-col>
                  </v-row>
                  <div
                    class="md-content md-table md-theme-default table_borders"
                    table-header-color="orange"
                    value
                  >
                    <div
                      class="md-content md-table-content md-scrollbar md-theme-default"
                    >
                      <table>
                        <thead class="md-card-header">
                          <tr>
                            <th class="md-table-head" style="position:relative">
                              <div
                                class="md-table-head-container md-ripple md-disabled"
                              >
                                <div class="md-table-head-label">
                                  Timestamp
                                </div>
                                <div class="search_column mt-1">
                                  <date-menu
                                    v-model="searchParams.date"
                                    @change="getFilterData"
                                  >
                                  </date-menu>
                                </div>
                              </div>
                            </th>

                            <th class="md-table-head">
                              <div
                                class="md-table-head-container md-ripple md-disabled"
                              >
                                <div class="md-table-head-label">
                                  Organizer
                                </div>
                                <div class="search_column">
                                  <v-autocomplete
                                    solo
                                    filled
                                    label="User"
                                    v-model="searchParams.user_id"
                                    item-value="id"
                                    item-text="name"
                                    :loading="isLoading"
                                    :items="['All', ...user_ids]"
                                    @change="getFilterData"
                                  ></v-autocomplete>
                                </div>
                              </div>
                            </th>

                            <th class="md-table-head">
                              <div
                                class="md-table-head-container md-ripple md-disabled"
                              >
                                <div class="md-table-head-label">
                                  Type
                                </div>
                                <div class="search_column">
                                  <v-autocomplete
                                    v-model="searchParams.post_type"
                                    solo
                                    filled
                                    label="Post Type"
                                    :items="['All', 'Event', 'Social', 'Games']"
                                    @change="getEventsLog"
                                  ></v-autocomplete>
                                </div>
                              </div>
                            </th>

                            <th class="md-table-head">
                              <div
                                class="md-table-head-container md-ripple md-disabled"
                              >
                                <div class="md-table-head-label">
                                  Service
                                </div>
                                <div class="search_column">
                                  <v-autocomplete
                                    solo
                                    filled
                                    background-color="#fff"
                                    label="Service"
                                    :items="venueServices"
                                    item-text="name"
                                    item-value="id"
                                    multiple
                                    v-model="searchParams.venue_service_ids"
                                    :rules="[
                                      (v) => !!v || 'Services is required',
                                    ]"
                                    @change="getEventsLog"
                                  >
                                    <template
                                      v-if="
                                        searchParams.venue_service_ids.length ==
                                          venueServices.length
                                      "
                                      v-slot:selection="{ index }"
                                    >
                                      <span v-if="index == 0"
                                        >All Services</span
                                      >
                                    </template>
                                    <template
                                      v-else
                                      v-slot:selection="{ item, index }"
                                    >
                                      <span v-if="index == 0">{{
                                        item.name
                                      }}</span>
                                      <span v-if="index == 1"
                                        >, {{ item.name }}</span
                                      >
                                      <span v-if="index == 2">, ...</span>
                                    </template>

                                    <template v-slot:prepend-item>
                                      <v-list-item
                                        ripple
                                        @click="
                                          toggle(
                                            'venueServices',
                                            'venue_service_ids'
                                          )
                                        "
                                      >
                                        <v-list-item-action>
                                          <v-icon
                                            :color="
                                              searchParams.venue_service_ids
                                                .length > 0
                                                ? 'indigo darken-4'
                                                : ''
                                            "
                                            >{{
                                              getIcon(
                                                "venueServices",
                                                "venue_service_ids"
                                              )
                                            }}</v-icon
                                          >
                                        </v-list-item-action>
                                        <v-list-item-content>
                                          <v-list-item-title
                                            >All</v-list-item-title
                                          >
                                        </v-list-item-content>
                                      </v-list-item>
                                    </template>
                                  </v-autocomplete>
                                </div>
                              </div>
                            </th>

                            <th class="md-table-head">
                              <div
                                class="md-table-head-container md-ripple md-disabled"
                              >
                                <div class="md-table-head-label">Post</div>
                              </div>
                            </th>
                      <th class="md-table-head">
                      <div
                        class="md-table-head-container md-ripple md-disabled"
                      >
                        <div class="md-table-head-label">
                          Make Featured
                        </div>
                      </div>
                      </th>
                            <th class="md-table-head">
                              <div
                                class="md-table-head-container md-ripple md-disabled"
                              >
                                <div class="md-table-head-label">Delete</div>
                              </div>
                            </th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr
                            class="md-table-row"
                            v-for="data in eventsData"
                            :key="data.id"
                          >
                            <td class="md-table-cell">
                              <div class="md-table-cell-container">
                                {{ data.created_at | timeStamp }}
                              </div>
                            </td>

                            <td class="md-table-cell">
                              <div class="md-table-cell-container">
                                <v-btn
                                  @click="
                                    $router.push({
                                      name: 'ViewUser',
                                      params: { userId: data.user_id },
                                    })
                                  "
                                  small
                                  color="normal"
                                  >{{
                                    data.user != null ? data.user.name : "NA"
                                  }}</v-btn
                                >
                              </div>
                            </td>
                            <td class="md-table-cell">
                              <div class="md-table-cell-container">
                                {{
                                  data.category != null
                                    ? data.category.service_type || "Sports"
                                    : "NA"
                                }}
                              </div>
                            </td>
                            <td class="md-table-cell">
                              <div class="md-table-cell-container">
                                {{
                                  data.category != null
                                    ? data.category.name
                                    : "NA"
                                }}
                              </div>
                            </td>
                            <td class="md-table-cell">
                              <div class="md-table-cell-container">
                                <v-btn
                                  color="#00b0af"
                                  small
                                  dark
                                  @click="showPostModel(data.id)"
                                  >View Post</v-btn
                                >
                              </div>
                            </td>
   <td class="md-table-cell">
                      <v-btn
                        v-if="data.is_featured == 1"
                        small
                        color="success"
                        class="d-inline-block text-truncate"
                        dark
                        @click="changeFeaturedStatus(data.id)"
                      >
                        <span class="text-truncate">Featured</span>
                      </v-btn>
                       <v-btn
                        v-else
                        small
                        color="primary"
                        class="d-inline-block text-truncate"
                        dark
                        @click="changeFeaturedStatus(data.id)"
                      >
                        <span class="text-truncate">Make It Featured</span>
                      </v-btn>
                      </td>
                            <td class="md-table-cell">
                              <v-btn
                                small
                                color="error"
                                class="d-inline-block text-truncate"
                                dark
                                @click="confirmDelete(data.id)"
                              >
                                <span class="text-truncate">Delete</span></v-btn
                              >
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <v-pagination
                    v-model="page"
                    :length="totalPages"
                    :page="page"
                    total-visible="10"
                  ></v-pagination>
                </div>
              </div>
            </div>
          </div>
        </v-row>
      </v-col>
    </v-row>
    <post-model v-bind="postModel" @close="postModel.postID = null" />
    <confirm-model
      v-bind="confirmModel"
      @confirm="confirmActions"
      @close="confirmModel.id = null"
    ></confirm-model>
    <user-model
      v-bind="userModel"
      @close="userModel.userID = null"
      @updated="search()"
    />
  </v-container>
</template>
<script>
import moment from "moment";
import PostModel from "./Post/PostModel";
import ConfirmModel from "@/components/Confirmation/ConfirmModel";
import UserModel from "../Users/User/UserModel.vue";
export default {
  data() {
    return {
      page: 1,
      user_ids: [],
      user_id: null,
      totalPages: 1,
      perPage: null,
      eventsData: [],
      isLoading: false,
      date1: moment()
        .subtract(30, "days")
        .format("YYYY-MM-DD"),
      date2: moment().format("YYYY-MM-DD"),
      flag: false,
      menu1: false,
      menu2: false,
      postModel: { postID: null, type: "details" },
      confirmModel: {
        id: null,
        title: null,
        description: null,
      },
      userModel: { userID: null, type: "details" },
      searchParams: {
        timestamp: null,
        start_date: moment()
          .subtract(30, "days")
          .format("YYYY-MM-DD"),
        end_date: moment().format("YYYY-MM-DD"),
        venue_service_ids: [],
      },
      timeDuration: [
        { name: "All", title: "All" },
        { name: "week", title: "This Week" },
        { name: "year", title: "This Year" },
        { name: "month", title: "This Month" },
        { name: "custom", title: "Custom Duration" },
      ],
    };
  },

  components: {
    PostModel,
    ConfirmModel,
    UserModel,
  },
  mounted() {
    this.$store.dispatch("SportsList");
    this.getPostUsers();
    this.getEventsLog();
  },
  computed: {
    date1Formatted() {
      return moment(this.date1, "YYYY-MM-DD").format("Do MMM YYYY");
    },
    date2Formatted() {
      return moment(this.date2, "YYYY-MM-DD").format("Do MMM YYYY");
    },
    venueServices() {
      return this.$store.getters.getSports.data;
    },
  },
  watch: {
    page() {
      this.getEventsLog();
    },
  },
  methods: {
    getIcon(type, field) {
      let icon = "mdi-checkbox-blank-outline";
      if (this.searchParams[field].length == this[type].length) {
        icon = "mdi-close-box";
      }
      if (
        this.searchParams[field].length > 0 &&
        this.searchParams[field].length != this[type].length
      )
        icon = "mdi-minus-box";

      return icon;
    },
    toggle(type, field) {
      this.$nextTick(() => {
        if (this.searchParams[field].length == this[type].length) {
          this.searchParams[field] = [];
        } else {
          this.searchParams[field] = this[type].map((x) => x.id);
        }
        this.getEventsLog();
      });
      this.$forceUpdate();
    },
    getPostUsers() {
      this.isLoading = true;
      this.$http
        .get("posts/admin/post-users")
        .then((response) => {
          if (response.status == 200 && response.data.status) {
            this.isLoading = false;
            this.user_ids = response.data.data;
          }
        })
        .catch((error) => {
          this.errorChecker(error);
        });
    },

    filterSearch(type, val) {
      if (val == "All") return;
      this.isLoading = true;
      this.$http
        .get("posts/admin/filter-events?field=" + type + "&search=" + val)
        .then((response) => {
          if (response.status == 200 && response.data.status) {
            this.isLoading = false;
            if (type == "title") {
              this.titles = response.data.data;
              this.titles.unshift(val);
              this.titles.unshift("All");
            } else if (type == "user") {
              this.user_ids = response.data.data;
              this.user_ids.unshift(val);
              this.user_ids.unshift("All");
            }
          }
        })

        .catch((error) => {
          this.errorChecker(error);
        });
    },
    getFilterData() {
      this.page = 1;
      this.getEventsLog();
    },
    showPostModel(postId) {
      this.postModel.postID = parseInt(postId);
      this.postModel.type = "details";
    },
    confirmDelete(id) {
      let msg =
        "This will delete the post. By clicking Yes you can confirm the operation.";
      this.confirmModel = {
        id: id,
        title: `Do you want to delete the post?`,
        description: msg,
        type:'delete'
      };
    },
    getEventsLog() {
      let url = "";

      if (
        typeof this.searchParams.user_id != "undefined" &&
        this.searchParams.user_id !== "All"
      ) {
        url += "&user_id=" + this.searchParams.user_id;
      }

      if (
        typeof this.searchParams.post_type != "undefined" &&
        this.searchParams.post_type !== "All"
      ) {
        let post_type = "All";
        if (this.searchParams.post_type == "Event") {
          post_type = "E";
        } else if (this.searchParams.post_type == "Social") {
          post_type = "S";
        } else if (this.searchParams.post_type == "Games") {
          post_type = "G";
        }
        url += "&post_type=" + post_type;
      }
      if (
        this.searchParams.venue_service_ids != "All" &&
        this.searchParams.venue_service_ids != null &&
        this.searchParams.venue_service_ids.length > 0
      ) {
        url += `&venue_service_id=${this.searchParams.venue_service_ids}`;
      }
      if (
        this.searchParams.time_intervel != "All" &&
        this.searchParams.time_intervel != null
      ) {
        // this.searchParams.end_date = moment().format("YYYY-MM-DD");
        if (this.searchParams.time_intervel == "custom") {
          this.flag = true;
        } else if (this.searchParams.time_intervel == "week") {
          this.searchParams.start_date = moment()
            .startOf("week")
            .format("YYYY-MM-DD");
        } else if (this.searchParams.time_intervel == "month") {
          this.searchParams.start_date = moment()
            .startOf("month")
            .format("YYYY-MM-DD");
        } else if (this.searchParams.time_intervel == "year") {
          this.searchParams.start_date = moment()
            .startOf("year")
            .format("YYYY-MM-DD");
        }
        url += "&end_date=" + this.searchParams.end_date;
        url += "&start_date=" + this.searchParams.start_date;
      }
      if (this.searchParams.date == null) {
        delete this.searchParams.date;
      } else if (typeof this.searchParams.date != "undefined") {
        url += "&timestamp=" + this.searchParams.date;
      }
      this.showLoader("Loading Posts");
      this.$http
        .get("admin/logs/events?page=" + this.page + "&per_page=10" + url)
        .then((response) => {
          this.hideLoader();
          if (response.status == 200 && response.data.status) {
            this.eventsData = response.data.data;
            this.totalPages = response.data.totalPages;
          }
        })
        .catch((error) => {
          this.errorChecker(error);
        });
    },
    changeFxn() {
      if (this.searchParams.time_intervel == "custom") {
        this.searchParams.start_date = moment()
          .subtract(30, "days")
          .format("YYYY-MM-DD");
        this.searchParams.end_date = moment().format("YYYY-MM-DD");
        this.flag = true;
      } else {
        this.flag = false;
        this.getEventsLog();
      }
    },
    viewPost(postId) {
      this.postID = postId;
    },
    setStatus(id, index) {
      this.$http
        .post(this.rootUrl + "post/blockUnblock/" + id)
        .then((response) => {
          if (response.status == 200 && response.data.status) {
            this.eventsData[index].is_disabled = response.data.disabledStatus;
            let status =
              response.data.disabledStatus == 1 ? "Disabled" : "Enabled";
            this.$toast.success("Success. Post has been " + status, {
              timeout: 10000,
              icon: "mdi-thumb-down",
              dismissable: true,
              showClose: true,
              closeText: "",
              closeIcon: "mdi-close-thick",
              closeColor: "white",
              queueable: true,
            });
          }
        })
        .catch((error) => {
          var response = error;
          if (
            typeof error.data == "undefined" &&
            typeof error.response != "undefined"
          ) {
            response = error.response;
          }
          let message =
            typeof response.data != "undefined" &&
            typeof response.data.message != "undefined"
              ? response.data.message
              : "Unknown Error.";
          this.$toast.error(message, {
            timeout: 10000,
            icon: "mdi-thumb-down",
            dismissable: true,
            showClose: true,
            closeText: "",
            closeIcon: "mdi-close-thick",
            closeColor: "white",
            queueable: true,
          });
        });
    },
    showUserModel(userId) {
      this.userModel.userID = parseInt(userId);
      this.userModel.type = "details";
    },
    confirmActions(data) {
      if(data.type=='featured')
      this.makeItFeatured(data.id);
    else
      this.changePostStatus(data.id);
      this.$forceUpdate();
      this.confirmModel.id = null;
    },
    changePostStatus(id) {
      this.$http
        .put(`posts/admin/toggle-status/${id}`)
        .then((response) => {
          if (response.status == 200) {
            this.showSuccess(`Event Deleted Successfully`);
            this.getEventsLog();
          }
        })
        .catch((error) => {
          this.errorChecker(error);
        });
    },
    gotoUser(username, userid) {
      this.$router.push({
        name: "ViewUser",
        params: { userid: userid },
      });
    },
    changeFeaturedStatus(id) {
      let msg =
        "This will Change the Featured Status. By clicking Yes you can confirm the operation.";
      this.confirmModel = {
        id: id,
        title: `Do you want to change Featured Status?`,
        description: msg,
        type:'featured'
      };
    },
    
    makeItFeatured(id) {
      this.$http
        .get(`admin/feed-post/featured-status-change/${id}`)
        .then((response) => {
          if (response.status == 200) {
            this.showSuccess(`Post status Successfully changed.`);
            this.getEventsLog();
          }
        })
        .catch((error) => {
          this.errorChecker(error);
        });
    },
  },
};
</script>
<style scoped>
.btn_bg {
  background-color: #fff;
  border-bottom: 3px solid #066a8c;
  border-radius: 10px;
  box-shadow: 0 3px 3px -2px black;
}
.mnuBtn {
  padding: 5px;
  font-size: 14px;
  font-weight: 700;
  color: #066a8c;
}
.pickers {
  width: 300px;
}
.text1 .v-input__control {
  border-bottom-right-radius: 0px;
  border-top-right-radius: 0px;
}
.text2 .v-input__control {
  border-bottom-left-radius: 0px;
  border-top-left-radius: 0px;
}
</style>
